<div class="modal-header">
  <h2 class="modal-title">Shared with</h2>
  <span class="ms-auto" (click)="activeModal.dismiss('Cross click')" role="button">
    <svg-icon [name]="'modal-close-menu'"></svg-icon>
  </span>
</div>
<div class="modal-body px-3 pb-3 pt-0">
  <div class="btn-group w-100 mb-3 d-flex">
    <span
      class="btn rounded-0 min-w-inherit btn-h42 fs-16 rounded-start-4"
      [ngClass]="activeSharedTab() ? 'btn-primary' : 'btn-outline-primary'"
      (click)="selectTab(true)"
    >
      <i class="bi bi-person-fill me-1"></i>Users
    </span>
    <span
      class="btn rounded-0 min-w-inherit btn-h42 fs-16 rounded-end-4"
      [ngClass]="!activeSharedTab() ? 'btn-primary' : 'btn-outline-primary'"
      (click)="selectTab(false)"
    >
      <i class="bi bi-people-fill me-1"></i>Groups
    </span>
  </div>

  @if (
    (activeSharedTab() && previousSharedUser().length > 0) || (!activeSharedTab() && previousSharedGroup().length > 0)
  ) {
    <div class="list-group mb-3 mh-200 overflow-y-auto">
      @for (item of activeSharedTab() ? previousSharedUser() : previousSharedGroup(); track item.id; let i = $index) {
        <div class="list-group-item p-0 position-relative">
          <div class="d-flex align-items-center gap-2 p-2">
            @if (!activeSharedTab()) {
              <i
                class="bi"
                [ngClass]="ariaExpanded()[i] ? 'bi-chevron-up' : 'bi-chevron-down'"
                (click)="toggleAriaExpanded(i)"
                [attr.aria-expanded]="ariaExpanded()[i]"
                data-bs-toggle="collapse"
                [attr.data-bs-target]="'#shared-group-collapse' + i"
              ></i>
            }

            <span class="d-flex gap-2 align-items-center">
              <span class="user-30" [ngClass]="!activeSharedTab() ? 'bg-primary' : ''">
                @if (!activeSharedTab()) {
                  <i class="bi bi-people-fill"></i>
                } @else {
                  {{
                    (item?.sharedWithUser?.name ?? '').split(' ')[0] + (item?.sharedWithUser?.name ?? '').split(' ')[1]
                      | FirstCapital
                  }}
                }
              </span>
            </span>

            <div class="flex-fill">
              <div class="d-flex flex-column">
                <h6 class="mb-0">
                  {{ activeSharedTab() ? item?.sharedWithUser?.name : item?.sharedWithGroup?.name }}
                </h6>

                @if (activeSharedTab()) {
                  <ng-container
                    *ngTemplateOutlet="
                      sharedPersonMeta;
                      context: {
                        $implicit: item?.sharedWithUser,
                        emailClass: 'fs-14',
                        dateFormat: 'MM/dd/yyyy, h:mm a'
                      }
                    "
                  ></ng-container>
                }
              </div>
            </div>

            <span
              class="text-danger fs-14 fw-500 cursor-pointer"
              [ngClass]="activeSharedTab() ? 'stretched-link' : ''"
              (click)="confirmRemoveAccess(item)"
              >Remove</span
            >
          </div>

          @if (!activeSharedTab() && (item?.sharedWithGroup?.sharedWithUsers?.length ?? 0) > 0) {
            <div class="collapse ps-2 bg-gray-pearl-white" [attr.id]="'shared-group-collapse' + i">
              <div class="d-flex flex-column gap-2 p-2 ps-4">
                @for (member of item?.sharedWithGroup?.sharedWithUsers; track member.id) {
                  <div class="d-flex align-items-center">
                    <span class="user-30"
                      >{{ member?.name?.split(' ')?.[0] ?? '' | FirstCapital
                      }}{{ member?.name?.split(' ')?.[1] ?? '' | FirstCapital }}</span
                    >
                    <div class="d-flex flex-column ms-2">
                      <h6 class="mb-0 fs-14">{{ member?.name }}</h6>
                      <ng-container
                        *ngTemplateOutlet="
                          sharedPersonMeta;
                          context: { $implicit: member, emailClass: 'fs-12', dateFormat: 'MMM d, y, h:mm a' }
                        "
                      ></ng-container>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (
    !isLoading() &&
    ((activeSharedTab() && previousSharedUser().length === 0) ||
      (!activeSharedTab() && previousSharedGroup().length === 0))
  ) {
    <div class="bg-gray-200 fs-16 fw-500 mb-3 p-3 rounded-2 text-center text-danger">
      No Shared {{ activeSharedTab() ? 'Users' : 'Groups' }} Found.
    </div>
  }

  <div class="d-flex justify-content-end gap-4">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Close</button>
  </div>
</div>

<!-- Shared email + "seen" status fragment, reused above for both a direct shared user
     and each member inside an expanded shared group. -->
<ng-template #sharedPersonMeta let-person let-emailClass="emailClass" let-dateFormat="dateFormat">
  <span [class]="emailClass" [innerHTML]="person?.email"></span>
  @if (person?.hasAccessed) {
    <span class="fs-12 text-body-secondary text-nowrap">
      <i class="bi bi-check2-all me-1"></i>Seen - {{ person?.accessedAt | date: dateFormat }}
    </span>
  }
</ng-template>
